// NETWORK
import RequestRabbit from './RequestRabbit';

// CONFIG
import config from '../Config';

const useTariffRequest = () => {
  const getTariffSchemes = async (errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/tariff/scheme`;
      const options = {
        method: 'GET',
      };

      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e);
    }
  };

  const getSchemeStatusTypes = async (errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/tariff/scheme/extra`;
      const options = {
        method: 'GET',
      };

      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e);
    }
  };

  const createNewTariffScheme = async (newTariffScheme, errorHandler) => {
    try {
      let url = `${config.baseServerURL}/admin/tariff/scheme`;
      const headers = new Headers({
        'Content-Type': 'application/json',
      });
      const options = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(newTariffScheme),
      };
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e);
    }
  };

  const getTariffScheme = async (tariffSchemeId, errorHandler) => {
    try {
      let url = `${config.baseServerURL}/admin/tariff/scheme/${tariffSchemeId}`;
      const options = {
        method: 'GET',
      };
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e);
    }
  };

  const updateTariffScheme = async (tariffSchemeId, updates, errorHandler) => {
    try {
      let url = `${config.baseServerURL}/admin/tariff/scheme/${tariffSchemeId}`;
      const headers = new Headers({
        'Content-Type': 'application/json',
      });
      const options = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(updates),
      };
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e);
    }
  };

  const deleteTariffSchemeById = async (tariffSchemeId, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/tariff/scheme/${tariffSchemeId}`;
      const options = {
        method: 'DELETE',
      };

      let response = await RequestRabbit.request(url, options, errorHandler);
      if (response.status > 399 && response.status < 600)
        errorHandler('Failed to delete Tariff Scheme.');
    } catch (e) {
      errorHandler(e);
    }
  };

  const cancelTariffSchemeId = async (tariffSchemeId, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/tariff/scheme/cancel/${tariffSchemeId}`;
      const options = {
        method: 'POST',
      };
      // Request
      let response = await RequestRabbit.request(url, options, errorHandler);

      if (response.status === 204) return true;
      errorHandler('Failed to cancel Tariff Scheme.');
    } catch (e) {
      errorHandler(e.message);
    }
  };

  const getTariffPlans = async (tariffSchemeId, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/tariff/scheme/${tariffSchemeId}/plan`;
      const options = {
        method: 'GET',
      };

      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e);
    }
  };

  const getPlanExtras = async (errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/tariff/scheme/plan/extra`;
      const options = {
        method: 'GET',
      };

      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e);
    }
  };

  const createNewTariffPlan = async (
    tariffSchemeId,
    newTariffPlan,
    errorHandler
  ) => {
    try {
      let url = `${config.baseServerURL}/admin/tariff/scheme/${tariffSchemeId}/plan`;
      const headers = new Headers({
        'Content-Type': 'application/json',
      });
      const options = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(newTariffPlan),
      };
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e);
    }
  };

  const updateTariffPlan = async (
    tariffSchemeId,
    tariffPlanId,
    updates,
    errorHandler
  ) => {
    try {
      let url = `${config.baseServerURL}/admin/tariff/scheme/${tariffSchemeId}/plan/${tariffPlanId}`;
      const headers = new Headers({
        'Content-Type': 'application/json',
      });
      const options = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(updates),
      };
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e);
    }
  };

  const deleteTariffPlan = async (
    tariffSchemeId,
    tariffPlanId,
    errorHandler
  ) => {
    try {
      const url = `${config.baseServerURL}/admin/tariff/scheme/${tariffSchemeId}/plan/${tariffPlanId}`;
      const options = {
        method: 'DELETE',
      };

      let response = await RequestRabbit.request(url, options, errorHandler);
      if (response.status > 399 && response.status < 600)
        errorHandler('Failed to delete Tariff Scheme.');
    } catch (e) {
      errorHandler(e);
    }
  };

  const cancelTariffPlanId = async (
    tariffSchemeId,
    tariffPlanId,
    errorHandler
  ) => {
    try {
      const url = `${config.baseServerURL}/admin/tariff/scheme/${tariffSchemeId}/plan/cancel/${tariffPlanId}`;
      const options = {
        method: 'POST',
      };
      // Request
      let response = await RequestRabbit.request(url, options, errorHandler);

      if (response.status === 204) return true;
      errorHandler('Failed to cancel Tariff Plan.');
    } catch (e) {
      errorHandler(e.message);
    }
  };

  const getLineExtras = async (errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/tariff/scheme/plan/line/extra`;
      const options = {
        method: 'GET',
      };

      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e);
    }
  };

  const getTariffLines = async (tariffSchemeId, tariffPlanId, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/tariff/scheme/${tariffSchemeId}/plan/${tariffPlanId}/line`;
      const options = {
        method: 'GET',
      };

      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e);
    }
  };

  const createNewTariffLine = async (
    tariffSchemeId,
    tariffPlanId,
    newTariffLine,
    errorHandler
  ) => {
    try {
      let url = `${config.baseServerURL}/admin/tariff/scheme/${tariffSchemeId}/plan/${tariffPlanId}/line`;
      const headers = new Headers({
        'Content-Type': 'application/json',
      });
      const options = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(newTariffLine),
      };
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e);
    }
  };

  const updateTariffLine = async (
    tariffSchemeId,
    tariffPlanId,
    tariffLineId,
    updates,
    errorHandler
  ) => {
    try {
      let url = `${config.baseServerURL}/admin/tariff/scheme/${tariffSchemeId}/plan/${tariffPlanId}/line/${tariffLineId}`;
      const headers = new Headers({
        'Content-Type': 'application/json',
      });
      const options = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(updates),
      };
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e);
    }
  };

  const deleteTariffLine = async (
    tariffSchemeId,
    tariffPlanId,
    tariffLineId,
    errorHandler
  ) => {
    try {
      const url = `${config.baseServerURL}/admin/tariff/scheme/${tariffSchemeId}/plan/${tariffPlanId}/line/${tariffLineId}`;
      const options = {
        method: 'DELETE',
      };

      let response = await RequestRabbit.request(url, options, errorHandler);
      if (response.status > 399 && response.status < 600)
        errorHandler('Failed to delete Tariff Scheme.');
    } catch (e) {
      errorHandler(e);
    }
  };

  return {
    getLineExtras,
    getPlanExtras,
    getSchemeStatusTypes,
    getTariffLines,
    getTariffPlans,
    getTariffScheme,
    getTariffSchemes,
    cancelTariffPlanId,
    cancelTariffSchemeId,
    deleteTariffLine,
    deleteTariffPlan,
    deleteTariffSchemeById,
    createNewTariffLine,
    createNewTariffPlan,
    createNewTariffScheme,
    updateTariffLine,
    updateTariffPlan,
    updateTariffScheme,
  };
};

export default useTariffRequest;
